import React, { useEffect, useState } from "react";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import { FieldArray, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { addFleetAsync } from "../../../../redux/features/fleetMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../../../AppRoutes/RouteName";

const validationSchema = Yup.object().shape({
   monthlyBudget: Yup.array().of(
      Yup.object().shape({
         amount: Yup.number().required("Amount is required"),
         toDate: Yup.date().required("To Date is required"),
         fromDate: Yup.date().required("From Date is required"),
      })
   ),
});

const initialValues = {
   monthlyBudget: [
      {
         amount: "",
         toDate: "",
         fromDate: "",
      },
   ],
};

function MonthlyMaintenanceBudget({
   step5Data,
   setStep5Data,
   setCurrentTabIndex,
   step1Data,
   step2Data,
   step3Data,
   step4Data,
}) {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const [initialState, setInitialState] = useState(initialValues);

   const handleNext = (formData) => {
      const vehicleDetails = { ...step1Data };
      const emi = { ...step2Data };
      const serviceRecords = [...step3Data];
      const tyres = [...step4Data];
      const monthlyBudget = [...formData.monthlyBudget];


      const data = {
         vehicle_no: vehicleDetails?.vehicleNo,
         chasis_no: vehicleDetails?.chasisNo,
         engine_no: vehicleDetails?.engineNo,
         vehicle_owner_name: vehicleDetails?.vehicleOwnerName,
         dimension_id: vehicleDetails?.dimension,
         fastag_bank_name: vehicleDetails?.fastagBankName,
         vehicle_category_id: vehicleDetails?.vehicleCategory,
         tonnage_id: vehicleDetails?.tonnage,
         make_id: vehicleDetails?.make,
         model: vehicleDetails?.model,
         registration_certificate: vehicleDetails?.registrationCertificate,
         insurance_expiry_date: vehicleDetails?.insuranceExpiryDate,
         insurance_amount: vehicleDetails?.insuranceAmount,
         insurance_certificate: vehicleDetails?.insuranceCertificate,
         fitness_expiry_date: vehicleDetails?.fitnessExpiryDate,
         fitness_amount: vehicleDetails?.fitnessAmount,
         fitness_certificate: vehicleDetails?.fitnessCertificate,
         local_permit_expiry_date: vehicleDetails?.localPermitExpiryDate,
         local_permit_amount: vehicleDetails?.localPermitAmount,
         local_permit_document: vehicleDetails?.localPermitDocument,
         national_permit_expiry_date: vehicleDetails?.nationalPermitExpiryDate,
         national_permit_amount: vehicleDetails?.nationalPermitAmount,
         national_permit_document: vehicleDetails?.nationalPermitDocument,
         puc_expiry_date: vehicleDetails?.pucExpiryDate,
         puc_amount: vehicleDetails?.pucAmount,
         puc_document: vehicleDetails?.pucDocument,
         mv_tax_expiry_date: vehicleDetails?.mvTaxExpiryDate,
         mv_tax_amount: vehicleDetails?.mvTaxAmount,
         mv_tax_document: vehicleDetails?.mvTax,
         gps_provider_name: vehicleDetails?.gpsProviderName,
         gps_amount: vehicleDetails?.gpsAmount,
         fabricator_name: vehicleDetails?.fabricatorName,
         fabricator_location: vehicleDetails?.fabricatorLocation,

         emi_start_date: emi?.emiStartDate,
         emi_end_date: emi?.emiEndDate,
         emi_amount: emi?.emiAmount,
         emi_certificate: emi?.emiCertificate,
         financed_by: emi?.financedBy,

         model_id: 3,
         action_id: 1,
      };

      const ard = {
         service_record_odometer_reading: serviceRecords?.map?.(
            (item) => item.odometerReading
         ),
         service_date: serviceRecords?.map?.((item) => item.serviceDate),
         service_amount: serviceRecords?.map?.((item) => item.serviceAmount),
         service_station_name: serviceRecords?.map?.((item) => item.serviceStationName),

         odometer_reading: tyres?.map?.((item) => item.odometerReading),
         tyre_type_id: tyres?.map?.((item) => item.tyreType),
         tyre_change_date: tyres?.map?.((item) => item.tyreChangeDate),
         tyre_amount: tyres?.map?.((item) => item.tyreAmount),
         tyre_station_name: tyres?.map?.((item) => item.tyreStationName),

         monthly_maintenance_budget_amount: monthlyBudget?.map?.((item) => item.amount),
         to_date: monthlyBudget?.map?.((item) => item.toDate),
         from_date: monthlyBudget?.map?.((item) => item.fromDate),
      };

      const newData = new FormData();

      Object.keys(data).forEach((key) => {
         newData.append(key, data[key]);
      });
      Object.keys(ard).forEach((key, index) => {
         newData.append(`${key}[]`, JSON.stringify(ard[key]));
      });

      serviceRecords?.forEach?.((item) => {
         newData.append("service_bill_upload[]", item.serviceBillUpload);
      });
      tyres?.forEach?.((item) => {
         newData.append("bill_upload_along_with_warranty_status[]", item.tyreBillUpload);
      });

      dispatch(backdropLoadingAction(true));
      dispatch(
         addFleetAsync({
            data: newData,
            err: () => {
               dispatch(backdropLoadingAction(false));
               toast.error("Something went wrong !");
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Record added successfully !");
               navigate(RouteNames.fleetMasterList);
            },
         })
      );
   };

   useEffect(() => {
      if (step5Data?.length > 0) {
         setInitialState((prev) => ({ monthlyBudget: step5Data }));
      }
   }, []);

   const formik = useFormik({
      initialValues: initialState,
      validationSchema: validationSchema,
      enableReinitialize: true,
      onSubmit: handleNext,
   });

   const { errors, touched, values, getFieldProps, handleSubmit, setFieldValue } = formik;

   return (
      <FormikProvider value={formik}>
         <div
            className="tab-pane fade show active"
            id="4"
            role="tabpanel"
            aria-labelledby="4"
         >
            <div className="col-lg-12">
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Monthly Maintenance Budget</h3>
                  </div>

                  <div className="card-body">
                     <FieldArray
                        name="monthlyBudget"
                        render={(arrayHelpers) => (
                           <div>
                              {values.monthlyBudget.map((item, index) => {
                                 return (
                                    <div
                                       className={
                                          index < values.monthlyBudget.length - 1 &&
                                          values.monthlyBudget.length > 1
                                             ? "row border-bottom mb-4 pb-3"
                                             : "row"
                                       }
                                    >
                                       <div className="col-lg-4">
                                          <CustomInput
                                             require
                                             inputType={"number"}
                                             label="Amount"
                                             id="fitnessAmount"
                                             placeholder="Enter Amount"
                                             {...getFieldProps(
                                                `monthlyBudget[${index}].amount`
                                             )}
                                             errors={
                                                Boolean(
                                                   touched?.monthlyBudget?.[index]?.amount
                                                ) &&
                                                Boolean(
                                                   errors?.monthlyBudget?.[index]?.amount
                                                )
                                             }
                                             message={
                                                errors?.monthlyBudget?.[index]?.amount
                                             }
                                          />
                                       </div>
                                       <div className="col-lg-4">
                                          <CustomDatePicker
                                             require
                                             label="To Date"
                                             id="serviceDate"
                                             placeholder="Select To Date"
                                             {...getFieldProps(
                                                `monthlyBudget[${index}].toDate`
                                             )}
                                             errors={
                                                Boolean(
                                                   touched?.monthlyBudget?.[index]?.toDate
                                                ) &&
                                                Boolean(
                                                   errors?.monthlyBudget?.[index]?.toDate
                                                )
                                             }
                                             message={
                                                errors?.monthlyBudget?.[index]?.toDate
                                             }
                                          />
                                       </div>
                                       <div className="col-lg-4">
                                          <CustomDatePicker
                                             require
                                             label="From Date"
                                             id="serviceDate"
                                             placeholder="Select From Date"
                                             {...getFieldProps(
                                                `monthlyBudget[${index}].fromDate`
                                             )}
                                             errors={
                                                Boolean(
                                                   touched?.monthlyBudget?.[index]
                                                      ?.fromDate
                                                ) &&
                                                Boolean(
                                                   errors?.monthlyBudget?.[index]
                                                      ?.fromDate
                                                )
                                             }
                                             message={
                                                errors?.monthlyBudget?.[index]?.fromDate
                                             }
                                          />
                                       </div>
                                       <div className="col-12">
                                          {values.monthlyBudget.length > 1 && (
                                             <button
                                                type="button"
                                                className="btn btn-danger float-left mb-3"
                                                onClick={() => {
                                                   arrayHelpers.remove(index);
                                                }}
                                             >
                                                <i className="fas fa-trash"></i> Delete
                                                item
                                             </button>
                                          )}
                                       </div>
                                    </div>
                                 );
                              })}
                           </div>
                        )}
                     />

                     <div className="row mt-4">
                        <div className="col-lg-6">
                           <button
                              type="button"
                              className="btn btn-primary float-left"
                              onClick={() => {
                                 setFieldValue("monthlyBudget", [
                                    ...values.monthlyBudget,
                                    { amount: "", toDate: "", fromDate: "" },
                                 ]);
                              }}
                           >
                              <i className="fas fa-plus"></i> Add More
                           </button>
                        </div>
                     </div>
                  </div>

                  <div className="card-body">
                     <div
                        style={{
                           maxWidth: "min-content",
                           display: "flex",
                           marginLeft: "auto",
                        }}
                     >
                        <button
                           className="btn btn-secondary px-4 py-3"
                           type="button"
                           onClick={() => setCurrentTabIndex((prev) => prev - 1)}
                        >
                           <h6 className="mb-0 text-uppercase">Back</h6>
                        </button>
                        <button
                           className="btn btn-primary btn-danger px-4 py-3 float-right ml-3"
                           type="button"
                           onClick={handleSubmit}
                        >
                           <h6 className="mb-0 text-uppercase">Submit</h6>
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </FormikProvider>
   );
}

export default MonthlyMaintenanceBudget;
